import { render, staticRenderFns } from "./RoughnessTemplate.vue?vue&type=template&id=0e4cd2b8"
import script from "./RoughnessTemplate.vue?vue&type=script&lang=js"
export * from "./RoughnessTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports